import { Trans, useTranslation } from 'react-i18next';
import { FIRST_SPIN_REWARD_FS } from '../../helpers';
import { ScOfferButton } from '../OfferCard/styled';
import { WinInfo } from '../WinInfo';
import { ScOfferSubtitle } from './styled';

interface IFirstStageOfferProps {
  onClaimOffer: () => void;
  translation: string;
}

export const FirstStageOffer = ({
  onClaimOffer,
  translation,
}: IFirstStageOfferProps) => {
  const { t } = useTranslation(translation);

  return (
    <>
      <WinInfo
        amount={t('fs', { fsCount: FIRST_SPIN_REWARD_FS })}
        title={t('youWon')}
      >
        <ScOfferSubtitle>
          <Trans
            components={{
              span: <span />,
            }}
            i18nKey="stage1.offer.subtitle"
            ns={translation}
          />
        </ScOfferSubtitle>
      </WinInfo>
      <ScOfferButton onClick={onClaimOffer} type="button">
        {t('stage1.offer.cta')}
      </ScOfferButton>
    </>
  );
};
